import { GET_USER_FLAGS, GET_USER_FLAGS_DONE, GET_USER_FLAGS_ERROR, HERO_ONLINE } from './actionTypes';
export const getUserFlags = () => ({ type: GET_USER_FLAGS });
export const doneGettingUserFlags = (data) => ({
    type: GET_USER_FLAGS_DONE,
    data
});
export const errorGettingUserFlags = (data) => ({
    type: GET_USER_FLAGS_ERROR,
    data
});
export const heroOnline = () => ({ type: HERO_ONLINE });
//# sourceMappingURL=actionCreators.js.map